export default "__VITE_ASSET__t_r$gyl4__"